<template>
    <answers ref="answers"
             code_question_group="GQ04"
             danger_code="MCAL25"
    />
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    }
};
</script>
